import { render, staticRenderFns } from "./customer-loan-request.vue?vue&type=template&id=0316053c&scoped=true&"
import script from "./customer-loan-request.vue?vue&type=script&lang=js&"
export * from "./customer-loan-request.vue?vue&type=script&lang=js&"
import style0 from "./customer-loan-request.vue?vue&type=style&index=0&id=0316053c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316053c",
  null
  
)

export default component.exports